export const ACTION_GET_COMPANY_CONFIG = "ACTION_GET_COMPANY_CONFIG";
export const ACTION_PUT_COMPANY_SURVEY_CONFIG = "ACTION_PUT_COMPANY_SURVEY_CONFIG";
export const ACTION_PUT_COMPANY_RAFFLE_CONFIG = "ACTION_PUT_COMPANY_RAFFLE_CONFIG";
export const ACTION_GET_WHITE_STAR_VALUES = "ACTION_GET_WHITE_STAR_VALUES";
